
        import {css} from 'lit-element';   
        export default css`:host sp-button{width:100%}`;
    